import '@sass/blocks/favorites/_favLink.scss'

import { updateFavoritedHouses } from "@js/parts/globals/favorites/functions/updateFavoritedHouses";
import { getCookie, setCookie, deleteCookie } from "@js/globalFunctions/cookieHandling";

$(document).ready(function() {
	updateFavoritedHouses();
	
	$(document).on('click', '.feriehus-item .fav-link, .newMapStylingEsMtm .fav-link, .favoriteArea .fav-link', function(e){
		e.preventDefault();
		
		const postid = (typeof $(this).attr("data-post-id") !== 'undefined') ? Number($(this).attr("data-post-id")) :  Number($(this).closest(".feriehus-item").attr("data-post-id")) ;
		const addText = (dataholder.lan === "da-dk") ? 'Føj til favorit' : 'Zu Merkliste';
		const removeText = (dataholder.lan === "da-dk") ? 'Fjern favorithus' : 'Aus Merkliste löschen';
		const cookieTest = (dataholder.lan === "da-dk") ? getCookie('favorithuse') : getCookie('favorithauser') ;
		
		if(typeof cookieTest != 'undefined'){
			const postArray = JSON.parse(cookieTest);
			const index = postArray.indexOf(postid);
			if($('.feriehus-item[data-post-id="'+postid+'"] .fav-link').hasClass('hasBeenSelected') || $('.fav-link[data-post-id="'+postid+'"]').hasClass('hasBeenSelected')){
				if (index > -1) {
					postArray.splice(index, 1);
					if(postArray.length === 0){
						if(dataholder.lan === "da-dk"){
							deleteCookie('favorithuse');
						}
						else
						{
							deleteCookie('favorithauser');
						}
						if( Number($(this).closest(".feriehus-item").attr("data-post-id")) === postid || Number($(this).attr("data-post-id")) === postid ){
							$(document).find(".feriehus-item[data-post-id='"+postid+"'] .fav-link, .fav-link[data-post-id='"+postid+"']").removeClass('hasBeenSelected');
							$(document).find(".feriehus-item[data-post-id='"+postid+"'] .fav-link span.text, .fav-link[data-post-id='"+postid+"'] span.text").text(addText);
						}
					}else{
						const json = JSON.stringify(postArray);
						if(dataholder.lan === "da-dk"){
							setCookie('favorithuse', json, 24*365);
						}else{
							setCookie('favorithauser', json, 24*365);
						}
						
						if( Number($(this).closest(".feriehus-item").attr("data-post-id")) === postid || Number($(this).attr("data-post-id")) === postid ){
							$(document).find(".feriehus-item[data-post-id='"+postid+"'] .fav-link, .fav-link[data-post-id='"+postid+"']").removeClass('hasBeenSelected');
							$(document).find(".feriehus-item[data-post-id='"+postid+"'] .fav-link span.text, .fav-link[data-post-id='"+postid+"'] span.text").text(addText);
						}
					}
				}
			}else{
				postArray.push(postid);
				const json = JSON.stringify(postArray);
				if(dataholder.lan === "da-dk"){
					setCookie('favorithuse', json, 24*365);
				}else{
					setCookie('favorithauser', json, 24*365);
				}
				if( Number($(this).closest(".feriehus-item").attr("data-post-id")) === postid || Number($(this).attr("data-post-id")) === postid ){
					$(document).find(".feriehus-item[data-post-id='"+postid+"'] .fav-link, .fav-link[data-post-id='"+postid+"']").addClass('hasBeenSelected');
					$(document).find(".feriehus-item[data-post-id='"+postid+"'] .fav-link span.text, .fav-link[data-post-id='"+postid+"'] span.text").text(removeText);
				}
			}
			
		}else{
			const json = JSON.stringify([postid]);
			if(dataholder.lan === "da-dk"){
				setCookie('favorithuse', json, 24*365);
			}else{
				setCookie('favorithauser', json, 24*365);
			}
			if( Number($(this).closest(".feriehus-item").attr("data-post-id")) === postid || Number($(this).attr("data-post-id")) === postid ){
				$(document).find(".feriehus-item[data-post-id='"+postid+"'] .fav-link, .fav-link[data-post-id='"+postid+"']").addClass('hasBeenSelected');
				$(document).find(".feriehus-item[data-post-id='"+postid+"'] .fav-link span.text, .fav-link[data-post-id='"+postid+"'] span.text").text(removeText);
			}
		}
		
		const finalTest = (dataholder.lan === "da-dk") ? getCookie('favorithuse') : getCookie('favorithauser') ;
		
		if(typeof finalTest == "undefined"){
			$(document).find(".favBasket").addClass("empty");
			$(document).find("#header-banner .tuv, #header-banner .holiday").removeClass("hidden");
		}else{
			$(document).find(".favBasket").removeClass("empty");
			$(document).find("#header-banner .tuv, #header-banner .holiday").addClass("hidden");
			$(document).find(".favBasket span.favCount").text(JSON.parse(finalTest).length);
		}
	});
});
